<template>
    <div class="c_table_wrap">
        <table class="memberInfo_table">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">
                    비밀번호
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="password" type="password" maxLength="20" @input="runValidator()"></el-input>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    비밀번호 확인
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="passwordConfirm" type="password" maxLength="20" @input="runValidator()"></el-input>
                    </div>
                </td>
            </tr>
        </table>
        <div class="input_error text-center mt20" v-if="validation.hasError('password')">{{ validation.firstError('password') }}</div>
        <div class="input_error text-center mt20" v-else-if="validation.hasError('passwordConfirm')">{{ validation.firstError('passwordConfirm') }}</div>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import memberValidator from "@/mixins/validators/memberValidator";
import EventBus from "@/utils/event-bus";

export default {
    name: "PasswordUpdateComponent",
    mixins: [alertMixins, memberValidator],
    components: {},
    inject: {

    },
    provide() {
        return {}
    },
    props: {
        memberKey: {default: 0},
        afterFunc: {default: () => {}},
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        EventBus.$on('runPasswordUpdate', this.checkValidator);

    },
    beforeDestroy() {
        EventBus.$off('runPasswordUpdate')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkValidator() {
            this.$validate(['password', 'passwordConfirm']).then(success => {
                if(success) {
                    this.updatePassword();
                }
            })
        },
        updatePassword() {
            let params = {
                g_type:'student',
                mb_type:'normal',
                mb_no: this.memberKey,
                mb_password:this.passwordConfirm,
            }
            try {
                this.$api.$member.updateMember(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type != 1) {
                        this.errorAlert('비밀번호 변경에 실패하였습니다.')
                    }else{
                        this.afterFunc();
                        this.createAlert({
                            content: '비밀번호가 변경되었습니다.',
                        })
                    }
                })
            }catch (e) {
                console.log(e);
            }

        },
        runValidator() {
            let validatorArr = [];
            if(this.password != '') {
                validatorArr.push('password')
            }
            if(this.passwordConfirm != '') {
                validatorArr.push('passwordConfirm')
            }
            this.$validate(validatorArr)
        },
    },
    watch: {
    },
}
</script>

<style scoped>

</style>
